<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getScannerErrorLogs"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-datetimepicker-range id="fieldset-log-date" label-cols-sm="4" label-cols-lg="3" label="Log Date" size="sm" :modelFrom.sync="filter.logDateFrom" :modelTo.sync="filter.logDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Control Card" id="filter-" size="sm" :model.sync="filter.controlCardId" @input="getControlCards" @focus="getControlCards" />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part" id="filter-" size="sm" :model.sync="filter.partId" @input="getParts" @focus="getParts" />
					<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer" id="filter-" size="sm" :model.sync="filter.customerId" @input="getCustomers" @focus="getCustomers" />
					<app-input-textbox id="fieldset-case-qty" label-cols-sm="4" label-cols-lg="3" label="Case Qty" label-for="filter-case-qty" size="sm" :model.sync="filter.caseQty" />
					<app-input-textbox id="fieldset-transaction-type" label-cols-sm="4" label-cols-lg="3" label="Transaction Type" label-for="filter-transaction-type" size="sm" :model.sync="filter.transactionType" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-transaction-id" label-cols-sm="4" label-cols-lg="3" label="Transaction Id" label-for="filter-transaction-id" size="sm" :model.sync="filter.transactionId" />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-sm="4" label-cols-lg="3" label="Pic" id="filter-" size="sm" :model.sync="filter.userId" @input="getUserInfos" @focus="getUserInfos" />
					<app-input-textarea id="fieldset-err-message" label-cols-sm="4" label-cols-lg="3" label="ErrMessage" label-for="filter-err-message" size="sm" :model.sync="filter.errMessageMultiple" />
					<app-input-textbox id="fieldset-input-type" label-cols-sm="4" label-cols-lg="3" label="Input Type" label-for="filter-input-type" size="sm" :model.sync="filter.inputType" />
					<app-input-textbox id="fieldset-input-type-id" label-cols-sm="4" label-cols-lg="3" label="Input Type Id" label-for="filter-input-type-id" size="sm" :model.sync="filter.inputTypeId" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getScannerErrorLogs"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Scanner Error Log</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false"  text="Action" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/scannererrorlog/ScannerErrorLog.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="false" 
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/scannererrorlog/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="false" 
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" to="/scannererrorlog/create" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="false"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-scannererrorlog" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="scannerErrorLogs" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="scannerErrorLogs.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Log Date" class="table-filter">
					<app-input-datetimepicker-range id="fieldset-log-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Log Date" size="sm" :modelFrom.sync="filter.logDateFrom" :modelTo.sync="filter.logDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getScannerErrorLogsWithoutLoading" />
				</b-th>
				<b-th stacked-heading="Control Card" class="table-filter">
					<v-select append-to-body label="controlCardNumber" :options="controlCards" :value="filter.controlCardId" :reduce="item => item.id" v-model="filter.controlCardId" :filterable="true" @input="getScannerErrorLogsWithoutLoading" @search="getControlCards"></v-select>
				</b-th>
				<b-th stacked-heading="Part" class="table-filter">
					<v-select append-to-body label="partNumber" :options="parts" :value="filter.partId" :reduce="item => item.id" v-model="filter.partId" :filterable="true" @input="getScannerErrorLogsWithoutLoading" @search="getParts"></v-select>
				</b-th>
				<b-th stacked-heading="Customer" class="table-filter">
					<v-select append-to-body label="code" :options="customers" :value="filter.customerId" :reduce="item => item.id" v-model="filter.customerId" :filterable="true" @input="getScannerErrorLogsWithoutLoading" @search="getCustomers"></v-select>
				</b-th>
				<b-th stacked-heading="Case Qty" class="table-filter">
					<b-form-input id="input-case-qty-table" @input="getScannerErrorLogsWithoutLoading" v-model="filter.caseQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Transaction Type" class="table-filter">
					<b-form-input id="input-transaction-type-table" @input="getScannerErrorLogsWithoutLoading" v-model="filter.transactionType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Transaction Id" class="table-filter">
					<b-form-input id="input-transaction-id-table" @input="getScannerErrorLogsWithoutLoading" v-model="filter.transactionId" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Pic" class="table-filter">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filter.userId" :reduce="item => item.id" v-model="filter.userId" :filterable="true" @input="getScannerErrorLogsWithoutLoading" @search="getUserInfos"></v-select>
				</b-th>
				<b-th stacked-heading="ErrMessage" class="table-filter">
					<b-form-input id="input-err-message-table" @input="getScannerErrorLogsWithoutLoading" v-model="filter.errMessage" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Input Type" class="table-filter">
					<b-form-input id="input-input-type-table" @input="getScannerErrorLogsWithoutLoading" v-model="filter.inputType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Input Type Id" class="table-filter">
					<b-form-input id="input-input-type-id-table" @input="getScannerErrorLogsWithoutLoading" v-model="filter.inputTypeId" size="sm"></b-form-input>
				</b-th>

						<b-th stacked-heading="Select All">
							<!-- <b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox> -->
						</b-th>
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(controlcard)="row">
						<a @click="() => ( $router.push({ name: 'scannererrorlogdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.controlCard.controlCardNumber != null && row.item.controlCard.controlCardNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.controlCard.controlCardNumber.slice(0, 30) + (row.item.controlCard.controlCardNumber.length > 30 ? "..." : "" ) : row.item.controlCard.controlCardNumber : "" }}
						</a>
					</template>

			<template v-slot:cell(logDate)="row">
				{{ row.item.logDate | moment("DD-MMM-YYYY HH:mm") }}
			</template>
			<template v-slot:cell(part)="row">
				{{ row.item.part != null ? row.item.part.partNumber : "" }}
			</template>
			<template v-slot:cell(customer)="row">
				{{ row.item.customer != null ? row.item.customer.code : "" }}
			</template>
			<template v-slot:cell(user)="row">
				{{ row.item.user != null ? row.item.user.firstName : "" }}
			</template>
				<template v-slot:cell(errmessage)="row">
					<app-long-text  :id="'errmessage-' + row.index" :text="row.item != null ? (row.item.errMessage != null && row.item.errMessage != '' ? row.item.errMessage : '') : ''" />
				</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<!-- <b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox> -->
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="partNumber" label-cols-sm="12" :model="row.item.partId" label="Part" :selected="row.item.part != null ? row.item.part.partNumber : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.customerId" label="Customer" :selected="row.item.customer != null ? row.item.customer.code : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-case-qty" label-cols-lg="12"  label="Case Qty" label-for="input-case-qty" size="sm" :model.sync="row.item.caseQty"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-transaction-type" label-cols-lg="12"  label="Transaction Type" label-for="input-transaction-type" size="sm" :model.sync="row.item.transactionType"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-transaction-id" label-cols-lg="12"  label="Transaction Id" label-for="input-transaction-id" size="sm" :model.sync="row.item.transactionId"   :isEditable="false" :isUpdatable="true" />
						<app-input-combobox optionsLabel="firstName" label-cols-sm="12" :model="row.item.userUserName" label="Pic" :selected="row.item.user != null ? row.item.user.firstName : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textarea id="fieldset-err-message" label-cols-lg="12"  label="ErrMessage" label-for="input-err-message" size="sm" :model.sync="row.item.errMessage"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-input-type" label-cols-lg="12"  label="Input Type" label-for="input-input-type" size="sm" :model.sync="row.item.inputType"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-input-type-id" label-cols-lg="12"  label="Input Type Id" label-for="input-input-type-id" size="sm" :model.sync="row.item.inputTypeId"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(scannerErrorLogsPaging != null ? scannerErrorLogsPaging.dataCount : 0)"
									:per-page="(scannerErrorLogsPaging != null ? scannerErrorLogsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-scannererrorlog.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-scannererrorlog.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ScannerErrorLog from '@/models/ScannerErrorLog/ScannerErrorLog';
import ScannerErrorLogList from '@/models/ScannerErrorLog/ScannerErrorLogList';
import ScannerErrorLogFilter from '@/filters/ScannerErrorLog/ScannerErrorLogFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import Customer from '@/models/Customer/Customer';
import AppInputTextbox from '@/components/AppInputTextbox';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		ScannerErrorLog, 
		ScannerErrorLogList, 
		ScannerErrorLogFilter, 
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"logDate": {}, "class" : "th-log-date first-child", "label" : "Log Date", key: 'logDate', sortable: true}, 
				{"controlCard": {}, "class" : "th-control-card", "label" : "Control Card", key: 'controlCard', sortable: true}, 
				{"part": {}, "class" : "th-part last-child", "label" : "Part", key: 'part', sortable: true}, 
				{"customer": {}, "class" : "th-customer d-stack-none", "label" : "Customer", key: 'customer', sortable: true}, 
				{"caseQty": {}, "class" : "th-case-qty d-stack-none", "label" : "Case Qty", key: 'caseQty', sortable: true}, 
				{"transactionType": {}, "class" : "th-transaction-type d-stack-none", "label" : "Transaction Type", key: 'transactionType', sortable: true}, 
				{"transactionId": {}, "class" : "th-transaction-id d-stack-none", "label" : "Transaction Id", key: 'transactionId', sortable: true}, 
				{"user": {}, "class" : "th-user d-stack-none", "label" : "Pic", key: 'user', sortable: true}, 
				{"errMessage": {}, "class" : "th-err-message d-stack-none", "label" : "ErrMessage", key: 'errMessage', sortable: true}, 
				{"inputType": {}, "class" : "th-input-type d-stack-none", "label" : "Input Type", key: 'inputType', sortable: true}, 
				{"inputTypeId": {}, "class" : "th-input-type-id d-stack-none", "label" : "Input Type Id", key: 'inputTypeId', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			scannerErrorLogs: [],
			scannerErrorLogsPaging: {},
			controlCards : [],
			parts : [],
			customers : [],
			userInfos : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	methods : {
		getScannerErrorLogs : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ScannerErrorLog.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.scannerErrorLogs = result.data
					this.scannerErrorLogsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getScannerErrorLogsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ScannerErrorLog.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.scannerErrorLogs = result.data
					this.scannerErrorLogsPaging = result
				}
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ScannerErrorLogFilter();
			this.getScannerErrorLogs();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getScannerErrorLogs();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ScannerErrorLog.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ScannerErrorLog.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ScannerErrorLog.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ScannerErrorLog.deleteData(this, id).then(result => {
				if (result)
				{
					this.getScannerErrorLogs();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ScannerErrorLog.deleteMultipleData(this).then(result => {
					this.getScannerErrorLogs();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableScannerErrorLogParent = document.getElementById('table-list-scannererrorlog').parentNode;
			tableScannerErrorLogParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableScannerErrorLogParent.scrollWidth - tableScannerErrorLogParent.offsetWidth) == Math.ceil(tableScannerErrorLogParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableScannerErrorLogParent = document.getElementById('table-list-scannererrorlog').parentNode;
			tableScannerErrorLogParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableScannerErrorLogParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ScannerErrorLogFilter();
		// this.getControlCards()
		// this.getParts()
		// this.getCustomers()
		// this.getUserInfos()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Scanner Error Log"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getScannerErrorLogs();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getScannerErrorLogs();
			}
		},
		sortDesc: {
			handler: function() {
				this.getScannerErrorLogs();
			}
		},
		currentPage: {
			handler: function() {
				this.getScannerErrorLogs();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getScannerErrorLogs();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ScannerErrorLog.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "scannererrorlogindex") {
					this.getScannerErrorLogsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "scanner_error_log").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
